/** @file unitRing: a circle (or an arc of it) in the plane of two unit-frame axes, as a polyline. */
import type { Vec3 } from '@zilo/pose3d-math/vec3/vec3';
import { GIZMO_METRICS } from './gizmoMetrics';

/**
 * `radius (cos(t) e_u + sin(t) e_v)` for `t` from `from` to `to` radians, `GIZMO_METRICS.segments` steps per full
 * turn (at least 1); `u`, `v` index the unit frame's axes. The default is the whole ring, starting at `e_u`.
 */
export function unitRing(u: number, v: number, radius: number, from = 0, to = 2 * Math.PI): Vec3[] {
  const steps = Math.max(1, Math.round((Math.abs(to - from) / (2 * Math.PI)) * GIZMO_METRICS.segments));
  return Array.from({ length: steps + 1 }, (_, i) => {
    const t = from + ((to - from) * i) / steps;
    const p: [number, number, number] = [0, 0, 0];
    p[u] = radius * Math.cos(t);
    p[v] = radius * Math.sin(t);
    return p;
  });
}
